let config = require('../../cc-config.json');
export const initialMapViewport = {
    position: [config.initialMapPosition[0], config.initialMapPosition[1]],
    zoom: config.initialZoomLevel,
};
// expose configured min/max zoom so map consumers can use them
export const minZoom = typeof config.minZoom === 'number' ? config.minZoom : 9;
export const maxZoom = typeof config.maxZoom === 'number' ? config.maxZoom : 18;
export const mapBackgroundColor = {
    light: '#F0EEEB',
    night: '#162639',
    night_outlines: '#162639',
    boroughs: '#ff0000',
};
